import Vue from 'vue'
const wx = require('weixin-js-sdk')
Vue.prototype.$wechat = wx
